/**
 * Retry budgets and the sleep helper shared by the dancer-media modules.
 */

/**
 * Finalise-write retry budget (BAL-696). Total attempts of the idempotent
 * upsert; only transient/timeout failures are retried, with a linear backoff
 * of `FINALIZE_RETRY_BASE_MS * attempt`.
 */
export const FINALIZE_MAX_ATTEMPTS = 3;
export const FINALIZE_RETRY_BASE_MS = 200;

/**
 * Read-call ceiling for {@link DancerMediaService.readStorageHead} (BAL-747).
 * Generous next to the ~1 KB it wants — real chunks are 16-64 KB, so one or two
 * reads cover it. This exists only so a stream of zero-length chunks cannot
 * loop forever.
 */
export const MAX_HEAD_READS = 64;

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
